import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const MissingScreenWrapper = styled.section`
  & + & {
    margin-top: ${Spacing.S32};
  }
`
